import React from "react";
import { Compass } from "lucide-react";
import Seo from "@/components/Seo";
import { Container } from "@/components/ui-kit/Section";
import { Reveal } from "@/components/motion/Reveal";
import Cta from "@/components/ui-kit/Cta";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page not found | ETAP"
        description="That page could not be found. Head back to the ETAP home, see how it works, or view pricing."
        path="/404"
        noindex
      />
      <section className="relative flex min-h-[80vh] items-center overflow-hidden pt-28">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 -z-10"
          style={{
            background: "radial-gradient(50% 40% at 50% 10%, rgba(197,254,237,0.5) 0%, rgba(197,254,237,0) 60%)",
          }}
        />
        <Container>
          <Reveal className="mx-auto max-w-xl text-center">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-etap-primary-50 text-etap-primary">
              <Compass className="h-7 w-7" aria-hidden="true" />
            </span>
            <p className="mt-6 font-display text-7xl font-extrabold tracking-tight text-etap-deep-900">404</p>
            <h1 className="mt-2 font-display text-2xl font-bold tracking-tight text-etap-deep-800">
              We could not find that page
            </h1>
            <p className="mx-auto mt-3 max-w-md text-etap-deep-600">
              The link may be old or mistyped. Here are a few good places to pick things back up.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Cta to="/" variant="primary" location="404-home" testId="notfound-home">
                Back to Home
              </Cta>
              <Cta to="/how-it-works" variant="outline" location="404-how" testId="notfound-how">
                How It Works
              </Cta>
              <Cta to="/pricing" variant="ghost" location="404-pricing" testId="notfound-pricing">
                Pricing
              </Cta>
            </div>
          </Reveal>
        </Container>
      </section>
    </>
  );
}
